import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
  CircularProgress,
} from "@mui/material";
import { showToast } from "../../CoreDataService";
import { useSelector } from "react-redux";

const TravelRuleLogin = ({ data }) => {
  const { brokerDetailedInfo } = useSelector((state) => state);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Handle Login
  const handleTravelRuleLogin = async () => {
    if (!username || !password) {
      showToast("error", "Please provide valid Username & Password");
      return;
    }

    setLoading(true);

    const payload = {
      user_name: username,
      password: password,
    };

    try {
      const response = await fetch(
        "https://accounts.paybito.com/api/home/loginTravelDataVerifier",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();
      setLoading(false);

      if (result.error.error_data !== 0) {
        showToast("error", result.error.error_msg);
        return;
      }

      let userTravelData = result.userTravelData;
      let action = result.userTravelData.action;
      userTravelData["username"] = username;
      localStorage.setItem("userTravelData", JSON.stringify(userTravelData));

      if (action.toLowerCase() === "send") {
        navigate("/travel-rule-recipient-info", {
          state: { userTravelData },
        });
      } else {
        navigate("/travel-rule-originator-info", {
          state: { userTravelData },
        });
      }
    } catch (error) {
      console.error("Error during login:", error);
      showToast("error", "An error occurred during login. Please try again.");
      setLoading(false);
    }
  };

  var frontPagebakgColor =
    "linear-gradient(90deg, " +
    brokerDetailedInfo?.color?.backgroundColor1 +
    " 0%, " +
    brokerDetailedInfo?.color?.backgroundColor2 +
    " 60%)";

  // Dynamic styling
  const bodyStyle = {
    background: frontPagebakgColor,
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background 0.3s ease",
  };

  const buttonStyle = {
    background: data?.styleOne ? data.backgroundButtonColorDynamic : "#1976d2",
    borderRadius: "12px",
    fontWeight: 600,
    textTransform: "none",
    height: 45,
    "&:hover": {
      background: data?.styleOne
        ? data.backgroundButtonColorDynamic
        : "#1565c0",
    },
  };

  return (
    <Box sx={bodyStyle}>
      <Card
        sx={{
          width: "100%",
          maxWidth: 420,
          borderRadius: 4,
          boxShadow: 6,
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            // background: data?.styleOne
            //   ? data.backgroundNavColorDynamic
            //   : "#1976d2",
            py: 2,
            textAlign: "center",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: "#000",
              fontWeight: 700,
              letterSpacing: 0.5,
            }}
          >
            Travel Rule Authentication
          </Typography>
        </Box>

        <CardContent sx={{ px: 4 }}>
          <Typography
            variant="subtitle2"
            sx={{ mb: 2, color: "text.secondary" }}
          >
            Please enter your credentials to proceed
          </Typography>

          {/* Username Field */}
          <TextField
            fullWidth
            label="Username"
            placeholder="Enter Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
            InputProps={{ sx: { borderRadius: "12px" } }}
            sx={{ mb: 3 }}
          />

          {/* Password Field */}
          <TextField
            fullWidth
            label="Password"
            placeholder="Enter Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
            InputProps={{ sx: { borderRadius: "12px" } }}
            sx={{ mb: 4 }}
          />

          {/* Submit Button */}
          <Button
            fullWidth
            variant="contained"
            onClick={handleTravelRuleLogin}
            sx={buttonStyle}
            disabled={loading || !username || !password}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Submit"
            )}
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default TravelRuleLogin;
